module.exports = __webpack_public_path__ + "static/designEditParts-d5700d2c2e308bbb833458d2ec7c120d.png";